import { IUser } from '@/shared/model/user.model';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { IMarketer } from '@/shared/model/marketer.model';
import { IAddress } from '@/shared/model/address.model';
import MarketerService from '@/pages/marketer/marketer.service';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { IMarketerStore } from './types';

const marketerService = new MarketerService();

export const actions: ActionTree<IMarketerStore, RootState> = {
  setMarketer({ commit }, newMarketer: IMarketer): void {
    commit('setMarketer', newMarketer);
  },
  setId({ commit }, newId: number): void {
    commit('setId', newId);
  },
  setBankAccountName({ commit }, newBankAccountName: string): void {
    commit('setBankAccountName', newBankAccountName);
  },
  setIbanNumber({ commit }, newIbanNumber: string): void {
    commit('setIbanNumber', newIbanNumber);
  },
  setCocRegistration({ commit }, newCocRegistration: string): void {
    commit('setCocRegistration', newCocRegistration);
  },
  setCocRegistrationContentType({ commit }, newCocRegistrationContentType: string): void {
    commit('setCocRegistrationContentType', newCocRegistrationContentType);
  },
  setUser({ commit }, newUser: IUser): void {
    commit('setUser', newUser);
  },
  setAddress({ commit }, newAddress: IAddress): void {
    commit('setAddress', newAddress);
  },
  setMarketers({ commit }, newMarketers: IMarketer[]): void {
    commit('setMarketers', newMarketers);
  },
  setRestaurants({ commit }, newRestaurants: IRestaurant[]): void {
    commit('setRestaurants', newRestaurants);
  },
  setModerator({ commit }, newModerator: IMarketer): void {
    commit('setModerator', newModerator);
  },
  async retrieveUser({ commit, rootGetters }) {
    try {
      const marketer = await marketerService.findByUserId(rootGetters.account.id);
      const subMarketers = await marketerService.getSubMarketers(marketer.id.toString());
      marketer.marketers = subMarketers;

      commit('setMarketer', marketer);
      return true;
    } catch (error) {
      if (error.response.status === 404) {
        return false;
      } else {
        throw error;
      }
    }
  },
  setTab({ commit }, newTab: string): void {
    commit('setTab', newTab);
  },
  setDrawer({ commit }, newDrawer: boolean): void {
    commit('setDrawer', newDrawer);
  },
  businessCardSimulator({ commit }): void {
    commit('businessCardSimulator');
  },
};
